import React, { useState } from 'react';
import cx from '../../../../styles';
import {gtmSend} from '../../../../helpers';


const MultiChoiceCarousel = (props) => {
   
    return(
        <div className={cx('multi-choice-carousel-wrap')}>
            {
                props.pollChoices && props.pollChoices.length !== 0 && 
                props.pollChoices.map((poll) => {
                    return(
                        <div key={poll.id} className={ poll.user_choice ? 'voted' : `${props.pollType === "postPoll" ? 'not-voted' : ''}`}>
                            <div>
                                <img src={poll.image} alt={poll.message} />
                                <span>{poll.message}</span>
                            </div>
                            {
                                props.pollType === 'prePoll' &&
                                    <input type='checkbox' onChange={(event)=> { if(props.pollSelect) props.pollSelect(event.target.checked,poll.id)}}/>
                                
                            } 
                            {
                                props.pollType === 'postPoll' && 
                                <div className={cx('percentage-bar')}>
                                    <div className={cx("poll-bar-row")}>
                                        <div className={cx('fill-bar')} style={{width : `${poll.percentage}%`}}></div>
                                    </div>

                                    <div className={cx('poll-percentage')}>{poll.percentage}%</div>
                                </div>
                                
                            }
                        </div>
                    );
                })
            }
        </div>
    );
}

export const MultiChoiceCarouselPrePoll = ({pollChoices, voteHandler, match,t}) => {
    const pollId = pollChoices[0].poll_id;
    const [pollArray, setPollArray] = useState([]);
    const pollSelect = (isChecked,choiceId) => {
        if(isChecked) {
            gtmSend('dynamic', 'Poll Card', 'click-select-multichoice-carousel', match.path);
            setPollArray([...pollArray,choiceId]);
        }else{
            gtmSend('dynamic', 'Poll Card', 'click-select-multichoice--carousel', match.path);
           setPollArray(pollArray.filter((id) => { return id !== choiceId}))
        }
    }

    return (
        <div className={cx('multi-choice-carousel')}>
            <MultiChoiceCarousel pollChoices={pollChoices} pollSelect={pollSelect} pollType={"prePoll"}/>
            <button className={cx("btn btn-submit")} onClick={() => { voteHandler(pollId,pollArray.toString()); gtmSend('dynamic', 'Poll Card', 'click-submit-multichoice-carousel', match.path)}}> {t("submit_vote")}</button>
        </div>
    );
}

export const MultiChoiceCarouselPostPoll = ({votes}) => {
    
    return (
        <div className={cx('multi-choice-carousel')}>
            <MultiChoiceCarousel pollChoices={votes} pollType={"postPoll"}/>
        </div>
    );
}
